import React from 'react'

// Original sidebar vectors from Figma frame 217, Group 6511.
export default ({ color = '#3C52EF', size = 16, style }) => (
  <svg width={size} height={size} viewBox="28 137 16 16" fill="none" style={style} aria-hidden="true">
    <circle cx="36" cy="145" r="8" fill={color} />
    <path
      d="M36.0573 138.657L36.4794 140.178C37.0798 142.343 38.7712 144.034 40.9358 144.635L42.4573 145.057L40.9358 145.479C38.7712 146.079 37.0798 147.771 36.4794 149.935L36.0573 151.457L35.6352 149.935C35.0348 147.771 33.3434 146.079 31.1788 145.479L29.6573 145.057L31.1788 144.635C33.3434 144.034 35.0348 142.343 35.6352 140.178L36.0573 138.657Z"
      fill="#FFFFFF"
    />
  </svg>
)
